import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TopBarComponent } from '@app/_layout/top-bar/top-bar.component';
import { getWidgetSettings } from '@app/app.reducer';
import { LsDropdownComponent } from '@axess/ng-limestone';
import { select } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TicketsWidgetSettings } from '@pages/widget-admin/widget-models.interface';
import { AgeRatingComponent } from '@ui/components/age-rating/age-rating.component';
import { delay, filter, first } from 'rxjs';

@Component({
  selector: 'app-top-bar-widget',
  templateUrl: './top-bar-widget.component.html',
  styleUrls: ['./top-bar-widget.component.scss'],
  standalone: true,
  imports: [AgeRatingComponent, TranslateModule, AsyncPipe, LsDropdownComponent]
})
export class TopBarWidgetComponent extends TopBarComponent implements OnInit {
  widgetSettings: TicketsWidgetSettings;
  displayHeader = false;

  ngOnInit() {
    this.store
      .pipe(
        select(getWidgetSettings),
        filter((widgetSettings) => !!widgetSettings && !!widgetSettings.ticketsWidget),
        delay(0),
        first()
      )
      .subscribe(({ ticketsWidget }) => {
        this.widgetSettings = ticketsWidget;
        this.displayHeader = !!ticketsWidget.header;
      });
  }
}
